<div class="error-container">
  <div class="error-box">
    <img src="assets/scania-logo.png" alt="Error" class="error-logo" />

    <h2>Oops! We can't find the page you're looking for.</h2>
    <p *ngIf="reason === 'Invalid orderTypeCode'">
      The order type code for order <strong>{{ orderNo }}</strong> is invalid.
    </p>
    <p *ngIf="reason !== 'Invalid orderTypeCode' && orderNo">
      The order number <strong>{{ orderNo }}</strong> was not found.
    </p>
    <p *ngIf="!orderNo && reason !== 'Invalid orderTypeCode'">
      The resource might have been moved or deleted.
    </p>

    <div class="button-group">
      <a routerLink="/" class="back-link">Go to Homepage</a>
      <a *ngIf="showOrdersLink" routerLink="/orders" class="back-link secondary">View Orders</a>
    </div>
  </div>
</div>
